import { ForwardedRef, ReactNode, forwardRef } from 'react';
import {
  ElementContainer,
  DEFAULT_ELEMENT_CONTAINER_PROPS,
} from './ElementContainer';
import { AttachmentProps } from '../../types';
import { getTypeInfo, NodeType } from '../types';

type AttachmentContainerProps = AttachmentProps & {
  children: ReactNode;
  draggingType?: NodeType;
};

export const DEFAULT_ATTACHMENTS_CONTAINER_PROPS =
  DEFAULT_ELEMENT_CONTAINER_PROPS;

export const AttachmentsContainer = forwardRef(
  (
    { children, draggingType, ...rest }: AttachmentContainerProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => (
    <ElementContainer
      ref={ref}
      ignoreChildrenDrag={getTypeInfo(draggingType)?.isContent}
      {...rest}
    >
      {children}
    </ElementContainer>
  )
);
